<script>
  import rawdata from '../data/lostdata';

  import * as d3 from 'd3';

  function formatLabel(length) {
    return (txt) => {
      if (txt.length >= length) {
        return txt.slice(0, length - 3) + '...';
      } else {
        return txt;
      }
    };
  }

  const format = formatLabel(19);

  const labelFormat = d3.format(',');
  const LABEL_UNIT = {
    avgYearLostPerDeath: 'ปีต่อคน',
    totalNumber: 'คน',
    totalLost: 'ปี',
  };

  const FIELDS_TH = {
    avgYearLostPerDeath: 'จำนวนปีที่เสียไปโดยเฉลี่ยต่อการตาย',
    totalNumber: 'จำนวนผู้เสียชีวิต',
    totalLost: 'การสูญเสียทั้งหมด',
  };

  let w = 500,
    h = 350;
  let selectionPersist = false,
    selection = 'อุบัติเหตุการขนส่ง';
  const RADIUS = 10,
    STROKE_WIDTH = 1.5,
    padding = { top: 75, right: 80, bottom: 40, left: 120 };

  $: Y = d3
    .scalePoint()
    .domain([...Array(10).keys()].map((d) => ++d))
    .range([padding.top, h - padding.bottom]);

  const fields = rawdata[0].map((d) => d.field);
  $: X = d3
    .scalePoint()
    .domain(fields)
    .range([padding.left, w - padding.right]);

  const causes = rawdata.map((d) => d[0].cause);

  $: line = d3
    .line()
    .x((d) => X(d.field))
    .y((d) => Y(d.rank));
</script>

<style lang="scss">
  .container {
    width: 100%;
    height: 350px;
  }

  .label {
    dominant-baseline: middle;
    &-causes {
      text-anchor: end;

      &.sliding {
        text-anchor: start;
      }
    }
    &-fields {
      text-anchor: start;
    }
    &-ranks {
      text-anchor: middle;
      fill: white;
      cursor: default;
    }
  }

  .tooltip {
    dominant-baseline: middle;
    text-anchor: start;

    &.lastcolumn {
      text-anchor: end;
    }
  }

  .causes {
    transition: 0.4s;
  }
</style>

<div
  class="container"
  bind:clientWidth={w}
  bind:clientHeight={h}
  on:mouseleave={() => (selectionPersist = false)}>
  <svg width="100%" height="100%">
    <clipPath id="causebox">
      <rect x="0" y="0" width={X('totalNumber') - 20} height={h} />
    </clipPath>
    <g class="label label-fields">
      {#each fields as field}
        <text
          x={X(field)}
          y={Y(1)}
          dy={-20}
          transform="rotate(-15, {X(field)}, {Y(1)})">
          {FIELDS_TH[field]}
        </text>
      {/each}
    </g>
    {#each rawdata as fields (fields)}
      <g
        class="causes causes-{fields[0].cause}"
        on:mouseenter={() => (selection = fields[0].cause)}
        on:mouseleave={() => (selection = selectionPersist ? selection : null)}
        on:click={() => {
          if (selectionPersist) selection = null;
          selectionPersist = !selectionPersist;
        }}
        style="opacity: {fields[0].cause === selection ? 1 : selection ? 0.25 : 1};">
        <text
          class="label label-causes"
          class:sliding={fields[0].cause === selection && fields[0].cause.length >= 18 && fields[0].cause !== 'อุบัติเหตุการขนส่ง'}
          x={X(fields[0].field)}
          dx={-20}
          y={Y(fields[0].rank)}
          clip-path="url(#causebox)">
          {#if fields[0].cause === selection}
            {#if fields[0].cause.length >= 18 && fields[0].cause !== 'อุบัติเหตุการขนส่ง'}
              <animate
                attributeName="dx"
                from="-20"
                to={-fields[0].cause.length * 10}
                dur={fields[0].cause.length * 0.25}
                begin="0s"
                repeatCount="indefinite" />
            {/if}
            {fields[0].cause}
          {:else}{format(fields[0].cause)}{/if}
        </text>
        {#each fields as d, i}
          <circle
            cx={X(d.field)}
            cy={Y(d.rank)}
            fill={d.cause === 'อุบัติเหตุการขนส่ง' ? 'var(--cl-ippd)' : 'gainsboro'}
            r={RADIUS} />
          {#if i !== fields.length - 1}
            <line
              x1={X(fields[i].field)}
              y1={Y(fields[i].rank)}
              x2={X(fields[i + 1].field)}
              y2={Y(fields[i + 1].rank)}
              fill="transparent"
              stroke={fields[0].cause === 'อุบัติเหตุการขนส่ง' ? 'var(--cl-ippd)' : 'gainsboro'}
              stroke-width={STROKE_WIDTH} />
          {/if}

          <!-- label -->
          <text x={X(d.field)} y={Y(d.rank)} class="label label-ranks">
            {d.rank}
          </text>

          <!-- tooltips -->
          <text
            class="tooltip"
            x={X(d.field)}
            y={Y(d.rank)}
            dx={RADIUS * 1.5}
            dy={RADIUS}
            opacity={selection === d.cause ? 1 : 0}>
            {labelFormat(d.value)} {' ' + LABEL_UNIT[d.field]}
          </text>
        {/each}
      </g>
    {/each}
  </svg>
</div>
